import WhistleSettingsLayout from '../../components/layout/whistleblower/settingsLayout';

const WhistleSettingsPage = () => {
  return <WhistleSettingsLayout />;
};

export default WhistleSettingsPage;
